export default __webpack_public_path__ + "static/media/Profile_Phil_Speech.dda0a573.png";